var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSortingPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.867,
    height: 14.844,
    viewBox: "0 0 24.867 14.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#748d6f;stroke-linecap:round;stroke-width:2px}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    transform: "translate(-27.988 -66.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(29.401 67.5)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    "data-name": "Line 18",
    className: "cls-1",
    transform: "translate(2.512)",
    d: "M0 0v12.37"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "m-33.546 1058.724 2.521 2.764 2.521-2.764",
    transform: "translate(33.546 -1048.644)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#748d6f",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    className: "cls-1",
    transform: "translate(41.374 68.5)",
    d: "M0 0h10.481"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    className: "cls-1",
    transform: "translate(41.374 73.5)",
    d: "M0 0h7.57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    "data-name": "Line 21",
    className: "cls-1",
    transform: "translate(41.374 78.5)",
    d: "M0 0h9.316"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortingPoint);
export default __webpack_public_path__ + "static/media/icon-sorting-point.9f942cdf.svg";
export { ForwardRef as ReactComponent };